import { Empty, H4, Id, Label, Loading } from "@dgs/core";
import { TFunction } from "i18next";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { HotelStayStatus } from "../../../../../admin/src/shared/types/hotelStay";
import { HotelSectionFormValues, HotelSummaryRequest, WayOfBooking } from "../../../shared/types/hotel";
import { useRegistrationForm } from "../../provider/registrationFormProviderContext";
import { HotelStaySummary } from "./HotelStaySummary";
import { HotelStayList } from "./HotestayList";

const getHotelStayHeading = (hasOneBooking: boolean, isBooking: boolean, i: number, t: TFunction) => {
	if (hasOneBooking) {
		return isBooking ? t("Booking") : t("Inquiry");
	}
	return isBooking ? t("{{number}}. Booking", { number: i + 1 }) : t("{{number}}. Inquiry", { number: i + 1 });
};

interface Props {
	guestId: Id | null;
	sectionId: number;
	formValues: HotelSectionFormValues;
}

export const HotelSummary: FC<Props> = ({ guestId, sectionId, formValues }) => {
	const { t } = useTranslation();
	const { getHotelSummary } = useRegistrationForm();
	const request: HotelSummaryRequest = {
		guestId: guestId === "new" ? null : guestId,
		hotelStays: formValues.hotelStays.map((hotelStay) => ({
			checkIn: hotelStay.checkIn,
			checkOut: hotelStay.checkOut,
			requestedHotelId: hotelStay.requestedHotelId,
			requestedRoomTypeId: hotelStay.requestedRoomTypeId,
		})),
	};

	const { data: hotelSummaries, isLoading } = getHotelSummary(sectionId, request);

	return (
		<section>
			<H4>{t("Hotel stays")}</H4>
			<HotelStayList>
				{isLoading && <Loading />}
				{hotelSummaries &&
					hotelSummaries.map((summary, index) => {
						const hotelStay = formValues.hotelStays[index];

						const isBooking =
							hotelStay.status === HotelStayStatus.BOOKING ||
							hotelStay.status === HotelStayStatus.CANCELLATION_REQUESTED ||
							summary.stayConfiguration.wayOfBooking === WayOfBooking.BOOKING;

						return (
							<HotelStaySummary
								key={index}
								summary={summary}
								formValues={hotelStay}
								heading={
									<>
										<span>{getHotelStayHeading(hotelSummaries.length === 1, isBooking, index, t)}</span>
										{hotelStay.cancellationRequested && <Label color="warning">{t("Cancellation requested")}</Label>}
									</>
								}
							/>
						);
					})}
			</HotelStayList>
			{hotelSummaries && hotelSummaries.length === 0 && <Empty>{t("No hotel stays have been selected.")}</Empty>}
		</section>
	);
};
